import React, { useRef, useEffect, useState } from 'react';
import { useIntersectionObserver } from '../hooks/useScrollEffects';

const ScrollReveal = ({ children, animation = 'fade-up', delay = 0, duration = 600 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef();
  const { entries, observe, unobserve } = useIntersectionObserver({
    threshold: 0.05,
    rootMargin: '0px 0px -20px 0px'
  });

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      observe(element);
    }
    
    return () => {
      if (element) {
        unobserve(element);
      }
    };
  }, [observe, unobserve]);

  useEffect(() => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          setIsVisible(true);
        }, delay);
      } else {
        setIsVisible(false);
      }
    });
  }, [entries, delay]);

  const getAnimationClass = () => {
    const animations = {
      'fade-up': 'animate-fadeUp',
      'fade-down': 'animate-fadeDown',
      'fade-left': 'animate-fadeLeft',
      'fade-right': 'animate-fadeRight',
      'scale-up': 'animate-scaleUp',
      'slide-up': 'animate-slideUp',
      'slide-down': 'animate-slideDown',
      'rotate-in': 'animate-rotateIn',
      'mirror': 'animate-mirror'
    };
    return animations[animation] || animations['fade-up'];
  };

  return (
    <div
      ref={elementRef}
      className={`scroll-reveal ${isVisible ? getAnimationClass() : 'scroll-hidden'}`}
      style={{
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`
      }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
